import React, { Component } from 'react';
import { connect } from 'react-redux';
import { initialize } from 'redux-form';
import { loadInstalmentPayments, exportInstalmentPayments } from './actions';
import Filter from './InstalmentsFilter';
import List from './InstalmentsList';
import authUtils from '../../auth/utils';
import { withTranslation } from 'react-i18next';

class Instalments extends Component {
	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleFilterReset = this.handleFilterReset.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
	}

	componentDidMount() {
		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
		this.props.initializeFilter(filter);
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		this.props.loadEntities({ ...filter, sortKey, sortDirection, pageSize, pageNumber });
	}

	handleFilterSubmit(filter, exportFormat) {
		const { sortKey, sortDirection, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });
		if (exportFormat) {
			this.exportData(filter, exportFormat);
		}
	}

	exportData(filter, exportFormat) {
		this.props.exportEntities(exportFormat, filter);
	}

	handleFilterReset() {
		this.handleFilterSubmit();
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}

	render() {
		const { isReadonly, instalmentPaymentTypes, paymentStatusTypes, t } = this.props;
		return <div>
			<Filter onSubmit={this.handleFilterSubmit} onReset={this.handleFilterReset}
				instalmentPaymentTypes={instalmentPaymentTypes} paymentStatusTypes={paymentStatusTypes} loading={this.props.pagination.loading || this.props.export.loading} />
			<List isReadonly={isReadonly} onFetchData={this.handleListEvent} data={this.props.data} {...this.props.pagination} />
		</div>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const {
		pagination,
		exports,
		entities: { instalmentPayments },
		lookups: { instalmentPaymentTypes, paymentStatusTypes },
		auth: { currentUser }
	} = state;

	const instalmentPaymentsPagination = pagination.instalmentPayments.all || { ids: [], pageNumber: 1, pageSize: 10 };
	const instalmentPaymentsExports = exports.instalmentPayments.all || {};

	return {
		data: instalmentPaymentsPagination.ids.map(id => instalmentPayments[id]),
		pagination: instalmentPaymentsPagination,
		export: instalmentPaymentsExports,
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'PaymentHistory'),
		instalmentPaymentTypes,
		paymentStatusTypes: paymentStatusTypes
			.filter(s => s.id !== 6) //exclude NotApproved
			.map(s => s.id === 3 ? { ...s, displayName: 'Failed' } : s)//rename Cancelled to Failed
	};
};

export default connect(mapStateToProps, {
	loadEntities: loadInstalmentPayments,
	exportEntities: exportInstalmentPayments,
	initializeFilter: (data, fields) => initialize('instalmentPaymentsFilter', data, fields)
})(withTranslation()(Instalments));